import React from "react";

export default function CardsIcon({ size = 36, fill = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M3 6h8v14H3V6zm2 2v10h4V8H5zm8-2h8v14h-8V6zm2 2v10h4V8h-4zM6 2h12v2H6V2z" />
    </svg>
  );
}
